<!-- <div *ngIf="show" class="modal-i">
  <div class="modal-i-content">
    <div class="close" (click)="closeModal()">
      <fa-icon [icon]="['fas', 'circle-xmark']"></fa-icon>
    </div>

    <div
      class="image-container"
      (mousedown)="startDrag($event)"
      (mousemove)="drag($event)"
      (mouseup)="stopDrag()"
      (mouseleave)="stopDrag()"
    >
      <img
        #imageElement
        [src]="imageUrl"
        alt="Zoom Image"
        (load)="onImageLoad()"
        [style.transform]="'scale(' + zoomLevel + ') translate(' + position.x + 'px, ' + position.y + 'px)'"
      />
    </div>

    <div class="zoom-controls">
      <button (click)="zoomOut()"><fa-icon [icon]="['fas', 'search-minus']"></fa-icon></button>
      <button (click)="zoomIn()"><fa-icon [icon]="['fas', 'search-plus']"></fa-icon></button>

    </div>
  </div>
</div> -->
<div *ngIf="show" class="modal-i">
  <div class="modal-i-content">
    <button class="close" type="button" aria-label="Close image viewer" (click)="closeModal()">
      <fa-icon [icon]="['fas', 'circle-xmark']"></fa-icon>
    </button>

    <!-- Direction Label -->
    <div class="direction-label">
      <span class="badge" [class.entry]="currentImage.direction === 'Entry'" [class.exit]="currentImage.direction === 'Exit'">
        {{ currentImage.direction }}
      </span>
      <span class="slide-counter">{{ currentSlideIndex + 1 }} / {{ images.length }}</span>
    </div>

    <div
      class="image-container"
      [class.is-zoomable]="zoomLevel > 1"
      [class.is-dragging]="isDragging"
      (mousedown)="startDrag($event)"
      (mousemove)="drag($event)"
      (mouseup)="stopDrag()"
      (mouseleave)="stopDrag()"
      (wheel)="onWheel($event)"
      (dblclick)="toggleZoom($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <div *ngIf="currentImageFailed" class="image-fallback">
        <div class="fallback-icon">IMG</div>
        <div class="fallback-text">No image available</div>
      </div>
      <img
        *ngIf="!currentImageFailed"
        #imageElement
        [src]="currentImage.url"
        alt="Vehicle Image"
        (load)="onImageLoad()"
        (error)="onImageError()"
        [style.transform]="'translate(' + position.x + 'px, ' + position.y + 'px) scale(' + zoomLevel + ')'"
      />
    </div>

    <!-- Navigation Controls -->
    <div class="navigation-controls" *ngIf="images.length > 1">
      <button 
        class="nav-btn prev" 
        (click)="previousSlide()" 
        [disabled]="currentSlideIndex === 0"
        title="Previous image (Arrow Left)">
        <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
      </button>
      <button 
        class="nav-btn next" 
        (click)="nextSlide()" 
        [disabled]="currentSlideIndex === images.length - 1"
        title="Next image (Arrow Right)">
        <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
      </button>
    </div>

    <!-- Zoom Controls -->
    <div class="zoom-controls">
      <button (click)="zoomIn()" title="Zoom In">
        <i class="bi bi-zoom-in"></i>
      </button>
      <button (click)="zoomOut()" title="Zoom Out">
         <i class="bi bi-zoom-out"></i>
      </button>
      <button (click)="resetZoom()" title="Reset Zoom">
        <i class="bi bi-arrow-counterclockwise"></i>
      </button>
    </div>
  </div>
</div>
